import { CdkAccordion, CdkAccordionItem } from '@angular/cdk/accordion';
import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../../environments/environment.interface';
import { Relative } from '../../../../api/app-types/relative.app';
import { ClientRelativesItem } from '../client-relatives-item/client-relatives-item';

@Component({
	selector: 'lvr-relatives-list',
	templateUrl: './client-relatives-list.html',
	styleUrl: './client-relatives-list.scss',
	imports: [CdkAccordion, CdkAccordionItem, TranslocoPipe, ClientRelativesItem, RouterLink],
})
export class ClientRelativesList {
	public readonly env = inject(ENVIRONMENT);
	public readonly showAddButton = input<boolean>(false);
	public readonly relatives = input.required<Relative[]>();
	public readonly title = input.required<string>();
}
